// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__asjCr","rootNoMargin":"styles_rootNoMargin__8H-EP"};